import { useState } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import GoodvaleLogo from '../../components/GoodvaleLogo';
import { usePresentation } from '../PresentationProvider';
import { catalog } from '../runtime';
import { useTranslation } from './useTranslation';
import FantasyGateScene from './FantasyGateScene';
import CourtyardGateScene from './CourtyardGateScene';

export default function PresentationGateSelection() {
  const { t, i18n } = useTranslation();
  const { choose } = usePresentation();
  const [preview, setPreview] = useState(null);
  const language = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'de';
  const weights = catalog.available.map(option => !preview ? 1 : option.id === preview ? 1.65 : .85);
  const divider = `${100 * weights[0] / weights.reduce((total, weight) => total + weight, 0)}%`;

  return <div className="presentation-gate-worlds" style={{ '--gate-divider': divider }}>
    <div className="presentation-gate-options" role="group" aria-label={t('presentation.gameMode')}>
      {catalog.available.map((option, index) => {
        const isSelected = preview === option.id;
        const optionName = t(`presentation.gateNames.${option.id}`, { defaultValue: option.labels[language] || option.labels.en });
        return <button
          key={option.id}
          type="button"
          className={`presentation-gate-option presentation-option-${option.id}${isSelected ? ' is-selected' : ''}`}
          style={{ flexGrow: weights[index] }}
          aria-pressed={isSelected}
          aria-label={t(isSelected ? 'presentation.confirmMode' : 'presentation.previewMode', { mode: optionName })}
          onClick={() => isSelected ? choose(option.id) : setPreview(option.id)}
        >
          <span className="presentation-gate-visual" aria-hidden="true">
            {option.id === 'fantasy' ? <FantasyGateScene selected={isSelected} /> : option.id === 'community' ? <CourtyardGateScene selected={isSelected} /> : <img src={catalog.package(option.id).preview} alt="" />}
          </span>
          <span className="presentation-gate-copy">
            <span className="presentation-gate-kicker">{t('presentation.gameMode')}</span>
            <span className="presentation-gate-name">{optionName}</span>
            <span className="presentation-gate-description">{t(`presentation.${option.id}Description`, { defaultValue: optionName })}</span>
          </span>
          <span className="presentation-gate-action" aria-hidden="true">
            {isSelected ? <Check size={16} /> : <ArrowRight size={16} />}
            {t(isSelected ? 'presentation.confirmPreview' : 'presentation.discoverMode')}
          </span>
        </button>;
      })}
    </div>
    <div className="presentation-gate-brand">
      <h1 className="presentation-gate-welcome">{t('presentation.welcome')}</h1>
      <GoodvaleLogo alt="" className="presentation-gate-logo" />
    </div>
    <span className="presentation-gate-announcement" role="status" aria-live="polite" aria-atomic="true">
      {preview ? t('presentation.previewSelected', { mode: t(`presentation.gateNames.${preview}`, { defaultValue: catalog.available.find(option => option.id === preview)?.labels[language] }) }) : ''}
    </span>
  </div>;
}
